import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnMW: CultureInfo = {
  name: 'en-MW',
  displayName: 'English (Malawi)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-MW',
  parent: CultureInfoEn
};
